import { getApi } from './api_instance'

export const getContentByType = async (type, dispatch) => {
  try {
    const { data } = await getApi({
      apiUrl: `/api/content/${type}`,
      dispatch
    })
    return data
  } catch (error) {
    throw error
  }
}
